import { AddDelete_Img } from '@/Components/hooks/Api';
import { Aes256Encrypt } from '@/Components/Common/Utility';

/** Same event Name tab Home listens for to reload {@link MasterName/GetData_MasterNamePhoto}. */
export const MASTER_NAME_PHOTO_UPLOADED_EVENT = 'master-name-photo-uploaded';

export function dispatchMasterNamePhotoUploaded(nameID, masterNameID) {
    if (typeof window === 'undefined') return;
    window.dispatchEvent(
        new CustomEvent(MASTER_NAME_PHOTO_UPLOADED_EVENT, {
            detail: { nameID, masterNameID },
        }),
    );
}

/**
 * Same request shape as Name tab {@link src/Components/Pages/Name/NameTab/Home/Home.jsx} `upload_Image_File`
 * (incident Name: NameID + MasterNameID, not master-dash NameID 0).
 *
 * @param {Array<{ file: File, json: object }>} rows
 * @param {string|number} loginPinID
 * @param {string|number} loginAgencyID
 */
export async function uploadMasterNamePhotosLikeNameTab(rows, loginPinID, loginAgencyID) {
    if (!Array.isArray(rows) || rows.length === 0) return null;

    const formdata = new FormData();
    const EncFormdata = new FormData();
    const newData = [];
    const EncDocs = [];

    for (let i = 0; i < rows.length; i += 1) {
        const r = rows[i];
        const j = r?.json || {};
        const val = {
            NameID: j.NameID,
            MasterNameID: j.MasterNameID,
            CreatedByUserFK: loginPinID,
            Comments: j.Comments,
            PictureTypeID: j.PictureTypeID,
            ImageViewID: j.ImageViewID,
            ImgDtTm: j.ImgDtTm,
            OfficerID: j.OfficerID,
            AgencyID: loginAgencyID,
        };
        const values = JSON.stringify(val);
        newData.push(values);
        const EncPostData = await Aes256Encrypt(JSON.stringify([JSON.stringify(val)]));
        EncDocs.push(EncPostData);
        formdata.append('file', r.file);
        EncFormdata.append('file', r.file);
    }
    formdata.append('Data', JSON.stringify(newData));
    EncFormdata.append('Data', EncDocs);

    return AddDelete_Img('MasterName/MasterName_Photo', formdata, EncFormdata);
}
